// כל הקמפיינים: כרטיסים עם תמונת באנר, חיפוש וסינון.
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { ErrorBox, Loading, useLoad } from '../components/ui';
import Icon from '../components/Icon';
import CampaignCard, { type CampaignRow } from '../components/CampaignCard';

const FILTERS: [string, string][] = [['all', 'הכול'], ['active', 'פעילים'], ['draft', 'טיוטות'], ['done', 'הסתיימו']];

export default function Campaigns() {
  const { data, error, loading } = useLoad<CampaignRow[]>('/api/campaigns?limit=200');
  const [q, setQ] = useState('');
  const [f, setF] = useState('all');
  const rows = useMemo(() => (data ?? []).filter((c) => (f === 'all' ? c.status !== 'archived' : c.status === f) && (`${c.name} ${c.client_name}`.toLowerCase().includes(q.trim().toLowerCase()))), [data, q, f]);
  return (
    <div>
      <div className="page-title">
        <div><h1>קמפיינים</h1><p>כל הקמפיינים של כל הלקוחות, עם הבאנר האחרון של כל אחד.</p></div>
        <Link className="btn primary" to="/new"><Icon name="plus" />קמפיין חדש</Link>
      </div>
      <div className="row" style={{ marginBottom: 20 }}>
        <input type="search" placeholder="חיפוש לפי שם קמפיין או לקוח" value={q} onChange={(e) => setQ(e.target.value)} aria-label="חיפוש קמפיינים" style={{ minWidth: 280 }} />
        <div className="tabs" style={{ margin: 0, border: 'none' }} role="group" aria-label="סינון לפי מצב">
          {FILTERS.map(([k, l]) => <button key={k} className={f === k ? 'active' : ''} aria-pressed={f === k} onClick={() => setF(k)}>{l}</button>)}
        </div>
      </div>
      <ErrorBox error={error} />
      {!data && loading && <Loading />}
      {data && rows.length === 0 && (
        <div className="card empty">
          <Icon name="megaphone" size={32} />
          <p style={{ margin: '8px 0 16px' }}>{data.length ? 'לא נמצאו קמפיינים שמתאימים לסינון.' : 'עדיין אין קמפיינים.'}</p>
          <Link className="btn primary" to="/new"><Icon name="plus" />קמפיין חדש</Link>
        </div>
      )}
      {rows.length > 0 && <div className="cards">{rows.map((c) => <CampaignCard key={c.id} c={c} />)}</div>}
    </div>
  );
}
